import React from 'react';
import { isAnyReviewLevel } from '@scale/shared/workerSlack/helpers';

const SlackChannelReviewLevels = (props: $FIXME) => {
  return (
    <>
      <div className="item-option-container">
        <label>Review Levels: </label>

        <div className="permission-boxes-container">
          {!!props.channel.reviewLevels &&
            !isAnyReviewLevel(props.channel.reviewLevels) &&
            props.channel.reviewLevels.map((level: any) => (
              <div
                key={level}
                className={`permission-box-container  permission-box-level-${level}`}
              >
                <div className="permission-box">
                  {level === -1 ? 'Attempters' : `L${level} Reviewers`}
                </div>
              </div>
            ))}
          {!!isAnyReviewLevel(props.channel.reviewLevels) && (
            <div className={`permission-box-container  permission-box-level-${null}`}>
              <div className="permission-box">All levels</div>
            </div>
          )}
        </div>
      </div>
      <style>{`
        label {
          font-weight: 500;
          padding-right: 4px;
        }
        .permission-boxes-container {
          display: flex;
          flex-wrap: wrap;
          max-width: 300px;
          margin-left: 8px;
        }
        .item-option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .permission-box-container {
          border-radius: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 4px;
        }

        .permission-box {
          padding: 4px 12px;
          white-space: nowrap;
        }

        .permission-box-level-null,
        .permission-box-level-undefined {
          border: 1px solid var(--color-RemoGreen);
        }

        .permission-box-level--1 {
          border: 1px solid var(--color-RemoGold);
        }

        .permission-box-level-0 {
          border: 1px solid var(--color-LightPeriwinkle);
        }

        .permission-box-level-1 {
          border: 1px solid var(--color-Periwinkle100);
        }

        .permission-box-level-10 {
          border: 1px solid var(--color-ScaleBlue);
        }

        .permission-box-level-12 {
          border: 1px solid var(--color-RemoGold);
        }

        .permission-box-level-qir_auditor {
          border: 1px solid var(--color-RemoGold);
        }

        .permission-box-level-qir_lead_auditor {
          border: 1px solid var(--color-RemoGold);
        }
      `}</style>
    </>
  );
};

export default SlackChannelReviewLevels;
